/**
 * De lo que la persona teclea a lo que el sistema de autenticación entiende.
 *
 * Supabase solo sabe autenticar por correo. MEGA entra por USUARIO, porque
 * ocho de sus quince operativos no tienen correo y esperar a que se abran uno
 * los dejaba fuera de la aplicación por tiempo indefinido.
 *
 * El apaño es una dirección interna que no es un buzón: «jbermudez» viaja
 * como «jbermudez@mega.local». Nadie la ve nunca —no se muestra, no se
 * imprime, no se le pide a nadie—; se arma aquí y aquí se queda.
 *
 * ESTE ES EL ÚNICO SITIO DEL PROYECTO QUE SABE DE ESTE APAÑO. El día que
 * Supabase permita autenticar por usuario, o que MEGA quiera otro dominio, se
 * cambia este archivo y nada más.
 */

/** El dominio de mentira. No recibe correo ni pretende recibirlo. */
const DOMINIO_INTERNO = 'mega.local'

/**
 * Devuelve la dirección con la que se pide la sesión.
 *
 * Si lo tecleado YA ES UN CORREO se respeta tal cual. Dos razones: el
 * administrador de ARKANO entra con el suyo de verdad, y quien por costumbre
 * escriba su correo completo no tiene por qué encontrarse con un error que no
 * entiende.
 */
export function direccionDeIngreso(loTecleado: string): string {
  const limpio = loTecleado.trim().toLowerCase()
  return limpio.includes('@') ? limpio : `${limpio}@${DOMINIO_INTERNO}`
}

/**
 * Al revés: de la dirección guardada al usuario que se le muestra a la
 * persona. Un correo de verdad se muestra entero; la dirección interna se
 * muestra sin el dominio, que es ruido.
 */
export function usuarioVisible(direccion: string | null | undefined): string {
  if (!direccion) return ''
  return direccion.endsWith(`@${DOMINIO_INTERNO}`)
    ? direccion.slice(0, -(DOMINIO_INTERNO.length + 1))
    : direccion
}
